var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#054BC7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26.217 12.755V4.8H1.602v17.436a1.025 1.025 0 0 0 1.025 1.026h13.498"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#054BC7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26.217 4.8 13.909 16.082 1.602 4.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.803,
    cy: 21.2,
    r: 5.6,
    stroke: "#054BC7",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#054BC7",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m22.004 21.44 1.919 1.86 3.5-3.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeCheck);
export default __webpack_public_path__ + "static/media/envelope-check.612cc8d8f02be8d2bfe08edc27834b40.svg";
export { ForwardRef as ReactComponent };